import { cva } from '@/styled-system/css';

export const textButtonLabelRecipe = cva({
  base: {},
  variants: {
    tone: {
      'brand': {
        color: { base: 'TextButton.brand.label.default' },
      },
      'neutral': {
        color: { base: 'TextButton.neutral.label.default' },
      },
      'neutral-fixed': {
        color: { base: 'TextButton.neutral-fixed.label.default' },
      },
      'subtle': {
        color: { base: 'TextButton.subtle.label.default' },
      },
      'critical': {
        color: { base: 'TextButton.critical.label.default' },
      },
    },
    onImpact: {
      true: {},
      false: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    textStyle: {
      'body': {},
      'body-bold': {},
      'body-sm': {},
      'body-sm-bold': {},
    },
  },

  compoundVariants: [
    {
      onImpact: false,
      disabled: false,
      css: {
        textDecoration: {
          base: 'TextButton.default',
          _groupHover: 'TextButton.hover',
          _groupActive: 'TextButton.hover',
        },
      },
    },
    {
      onImpact: true,
      disabled: false,
      css: {
        textDecoration: {
          base: 'TextButton.onImpact.default',
          _groupHover: 'TextButton.onImpact.hover',
          _groupActive: 'TextButton.onImpact.hover',
        },
      },
    },
    {
      tone: 'brand',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.brand.label.hover',
          _groupActive: 'TextButton.brand.label.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.neutral.label.hover',
          _groupActive: 'TextButton.neutral.label.pressed',
        },
      },
    },
    {
      tone: 'subtle',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.subtle.label.hover',
          _groupActive: 'TextButton.subtle.label.pressed',
        },
      },
    },
    {
      tone: 'critical',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.critical.label.hover',
          _groupActive: 'TextButton.critical.label.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.neutral-fixed.label.hover',
          _groupActive: 'TextButton.neutral-fixed.label.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.neutral.label.default',
          _groupHover: 'TextButton.onImpact.neutral.label.hover',
          _groupActive: 'TextButton.onImpact.neutral.label.pressed',
        },
        textDecoration: {
          base: 'TextButton.onImpact.neutral.default',
          _groupHover: 'TextButton.onImpact.neutral.hover',
          _groupActive: 'TextButton.onImpact.neutral.hover',
        },
      },
    },
    {
      tone: 'brand',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.brand.label.default',
          _groupHover: 'TextButton.onImpact.brand.label.hover',
          _groupActive: 'TextButton.onImpact.brand.label.pressed',
        },
      },
    },
    {
      tone: 'critical',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.critical.label.default',
          _groupHover: 'TextButton.onImpact.critical.label.hover',
          _groupActive: 'TextButton.onImpact.critical.label.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'TextButton.onImpact.neutral-fixed.label.default',
          _groupHover: 'TextButton.onImpact.neutral-fixed.label.hover',
          _groupActive: 'TextButton.onImpact.neutral-fixed.label.pressed',
        },
      },
    },
  ],
});
